import { ReactNode } from 'react';
import { SuggestedFaqStatus } from '@/models/suggestedFaq.model';
import { StyledStatusPill } from './StatusPillStyles';

type TStatusPillProps = {
  status: SuggestedFaqStatus;
  className?: string;
  children: ReactNode;
};

export const StatusPill = ({ status, className, children }: TStatusPillProps) => (
  <StyledStatusPill $status={status} className={className}>
    {children}
  </StyledStatusPill>
);
